import type { SVGProps } from "react";
const SvgArrowLeft01Sharp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M12.5 5 8.09 9.41c-.279.279-.417.417-.417.59s.138.312.416.59L12.5 15"
    />
  </svg>
);
export default SvgArrowLeft01Sharp;
